import userAxios from './userAxios'
import authenticationAxios from "./authenticationAxios";

export const users = () => {
  return userAxios.get(`/users`, )
}

export const user = (userId) => {
  return userAxios.get(`/${userId}`)
}

export const postUser = (user) => {
  return userAxios.post(`/create`, user)
}

export const putUser = (user) => {
  return userAxios.put(`/update`, user)
}

export const roles = () => {
  return userAxios.get(`/roles`, )
}

export const resetUser = (user) => {
  return userAxios.put(`/reset`, user)
}

export const enableUser = (user) => {
  return userAxios.put(`/enable`, user)
}

export const disableUser = (user) => {
  return userAxios.put(`/disable`, user)
}

export const deleteUser = (user) => {
  return userAxios.put(`/delete`, user)
}

export const profile = (username) => {
  return userAxios.get(`/profile/${username}`)
}

export const putProfile = (profile) => {
  return userAxios.put(`/profile/update`, profile)
}

export const approveOTP = (otp) => {
  return authenticationAxios.post(`/approve/otp/verify`, otp)
}

export const getUserStats = () =>{
  return userAxios.get(`/users/stats`)
}

export const updatePassword = (cred) =>{
  return userAxios.put(`/user/reset`,cred)
}

export const hasBankAuthorizer=(bankId)=>{
  return userAxios.get(`/${bankId}/hasbankauthorizer/`)
}


export const hasBankAdminCorporate=()=>{
  return userAxios.get(`/users/hasbankcorporate/`)
}

export const getCorporateAuthorizationUserType = (bankId,corporate) => {
  return userAxios.get('/'+bankId+'/'+corporate+'/auth/type/')
}

export const getUserCorporates=(bankId,role)=>{
  return userAxios.post(`/users/${bankId}/usercorporates/`,role)
}

